import { ExternalLink } from "lucide-react";
import { Button } from "~/atoms/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "~/atoms/card";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { getOAuthLogin } from "~/api/v2/requests";

type SignInStepProps = {
  tenantId: string | null;
};

export const SignInStep = ({ tenantId }: SignInStepProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    try {
      const { codeVerifier, state, redirectUrl } = await getOAuthLogin();
      sessionStorage.setItem("sp_oauth_code_verifier", codeVerifier);
      sessionStorage.setItem("sp_oauth_state", state);
      window.location.href = redirectUrl;
    } catch (error) {
      console.error("Failed to initiate Sign In:", error);
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <span>{t(($) => $.sharepoint.steps.signIn.header)}</span>
        </CardTitle>
        <CardDescription>
          {t(($) => $.sharepoint.steps.signIn.subtitle)}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4">
          <h3 className="font-semibold">
            {t(($) => $.sharepoint.steps.signIn.authDetails)}
          </h3>
          <div className="text-muted-foreground space-y-2 text-sm">
            <p>• {t(($) => $.sharepoint.steps.signIn.sessionUsage)}</p>
            <p>• {t(($) => $.sharepoint.steps.signIn.tenantStorage)}</p>
            <p>• {t(($) => $.sharepoint.steps.signIn.revokeAccess)}</p>
          </div>
        </div>

        <div className="rounded-lg border border-green-200 bg-green-50 p-4">
          <div className="text-sm">
            <strong>{t(($) => $.sharepoint.steps.signIn.tenantId)}</strong>{" "}
            <code className="text-xs">{tenantId}</code>
          </div>
        </div>

        <CardFooter>
          <Button onClick={handleSignIn} disabled={loading}>
            <ExternalLink className="mr-2 h-4 w-4" />
            {loading
              ? t(($) => $.sharepoint.steps.adminConsent.redirecting)
              : t(($) => $.sharepoint.steps.signIn.signInButton)}
          </Button>
        </CardFooter>
      </CardContent>
    </Card>
  );
};
